import React, { FocusEvent } from 'react'
import { connect } from 'react-redux'
import { getPending } from 'loankeeper-common/helpers/SimpleFetchManager'
import { formValueSelector } from 'redux-form'

import FormField from '../../shared/newFormElements'

import { searchAccountAndInitialize } from '../helpers'
import { AccountFieldProps } from './components.types'

class AccountField extends React.Component<AccountFieldProps> {
  enterPressed = false

  checkDebit = (e) => {
    const { debitCCY, creditCCY, CCY } = this.props
    if (e.keyCode === 13 && e.target.value) {
      this.enterPressed = true
      e.preventDefault()

      this.props.checkAccount(e.target.value, e.target.name === 'DebitAccNo' ? debitCCY || CCY : creditCCY || CCY)

      if (this.props.searchButtonRef) this.props.searchButtonRef.focus()
    }
  }

  handleLostFocus = (e: FocusEvent<HTMLInputElement>) => {
    const { debitCCY, creditCCY, CCY } = this.props
    try {
      if (!this.enterPressed) {
        this.props.checkAccount(e.target.value, e.target.name === 'DebitAccNo' ? debitCCY || CCY : creditCCY || CCY)
      }
    } finally {
      this.enterPressed = false
    }
  }

  render() {
    const { checking, name, disabled, isRequired } = this.props

    return (
      //@ts-ignore
      <FormField
        type="number"
        maxLength="16"
        loading={checking}
        disabled={disabled || checking}
        name={name}
        onKeyDown={this.checkDebit}
        required={isRequired}
        onBlur={this.handleLostFocus}
        dontParseToInt
      />
    )
  }
}

const mapStateToProps = (state: {}, { fetcherName, FormName }: any) => {
  const selector = formValueSelector(FormName)
  return {
    checking: getPending(fetcherName)(state),
    CCY: selector(state, 'CCY'),
    debitCCY: selector(state, 'debitCCY'),
    creditCCY: selector(state, 'creditCCY'),
  }
}

//@ts-ignore
export default connect(mapStateToProps, (dispatch, { fetcherName, FormName, accountCredentials }) => ({
  checkAccount: (accountNo: string, ccyName: string) => {
    searchAccountAndInitialize({
      dispatch,
      fetcherName,
      accountNo,
      FormName,
      accountCredentials,
      ccyName,
    }).catch((error) => console.error(error))
  },
}))(AccountField)
